import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isPosting: false,
}

export const submitStatusSlice = createSlice({
  name: 'submitStatus',
  initialState,
  reducers: {
    changeSubmitStatus: (state, action) => {
      return {
        ...state,
        isPosting: action.payload,
      }
    },
  },
})

export const { changeSubmitStatus } = submitStatusSlice.actions
export default submitStatusSlice.reducer
